import React from 'react'
import ScfoButton from '../ScfoButton/ScfoButton'
import './modal-actions-footer.css'

export default function ModalActionsFooter({
  className = '',
  left = null,
  cancelLabel = 'Cancelar',
  onCancel,
  confirmLabel,
  onConfirm,
  confirmDisabled = false,
  confirmLoading = false,
  confirmVariant = 'primary',
  cancelVariant = 'ghost',
  confirmAsync = true,
}) {
  return (
    <div className={`modal-actions-footer ${className}`.trim()}>
      <div className="modal-actions-footer__left">{left}</div>
      <div className="modal-actions-footer__actions">
        {onCancel ? (
          <ScfoButton type="button" variant={cancelVariant} onClick={onCancel}>
            {cancelLabel}
          </ScfoButton>
        ) : null}
        {confirmLabel && onConfirm ? (
          <ScfoButton
            type="button"
            variant={confirmVariant}
            onClick={onConfirm}
            disabled={confirmDisabled}
            loading={confirmLoading}
            async={confirmAsync}
          >
            {confirmLabel}
          </ScfoButton>
        ) : null}
      </div>
    </div>
  )
}
